export default (state = {}, action = {}) => {
    switch (action.type) {
        case "INITIATE_TRANSECTION_WAITING":
            return {
                pending: true,
                success: false,
                data: {},
            };
        case "INITIATE_TRANSECTION_SUCCESS":
            return {
                pending: false,
                success: true,
                data: action.payload,
            };
        case "INITIATE_TRANSECTION_ERROR":
            return {
                pending: false,
                success: false,
                data: action.payload,
            };
        default:
            return state;
    }
};
